export default __webpack_public_path__ + "static/footer-image-d9b7af752c7742dcf84ee61b625e2e5b.jpg";